export enum StatusAlertEnum {
    ACTIVE,
    TERMINATED,
    UNAUTHORIZED,
}